import { ENTER_KEYCODE } from 'coreOld/constants';
import { goTo } from 'coreOld/utils';
import { oldPartsPath } from 'partsOld/routes/routePaths';

import PartSearchView from './PartSearchView';

const PartSearch = () => {
  const goToParts = (search?: string) => {
    goTo(oldPartsPath(search));
  };

  const handleOnKeyDown = (event, search: string) => {
    if (event?.keyCode === ENTER_KEYCODE) {
      event.preventDefault();

      goToParts(search);
    }
  };

  return <PartSearchView goToParts={goToParts} onKeyDown={handleOnKeyDown} />;
};

export default PartSearch;
